import { Typography } from 'libs/ui';

export const renderText = (text: string) => (
  <Typography variant="caption">{text}</Typography>
);
